"use client";
import { useRouter } from "next/navigation";

export default class RouteService {
  // redirects on the client/browser
  static redirect(page, path) {
    const router = useRouter();
    return router.push(page || "/index.js", path, { shallow: true });
  }

  // replaces on the client/browser
  static replace(path) {
    const router = useRouter();
    return router.replace(path);
  }

  static replaceOnServer(path) {
    return window.location.replace(path);
  }

  // check that resource
  static checkResponseError(response) {
    const router = useRouter();
    let _responseStatus = response.Errors.find((error) => !!error.Status);

    if (_responseStatus && _responseStatus.Status === 404) {
      router.push("/404");
    }
  }
}
